export const defaultParamKey = "currentElement";

export const urlElementsParams = {
  orderPopup: "orderPopup",
  dialogPopup: "dialogPopup",
};
